import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch, Prop, Emit } from 'vue-property-decorator';

@Component({
})
export default class ProductSortPanel extends Vue {
    @Prop({ default: 'grid' }) viewListMode!: 'grid' | 'list'
    @Prop({ default: '' }) initialSortBy!: string
    sortBy = {
        viewName: 'Артикулу (А - Я)',
        name: 'vend_asc',
    }
    sortList = [
        {
            viewName: 'Артикулу (А - Я)',
            name: 'vend_asc',
        },
        {
            viewName: 'Артикулу (Я - А)',
            name: 'vend_desc',
        },
        {
            viewName: 'Названию (А - Я)',
            name: 'name_asc',
        },
        {
            viewName: 'Названию (Я - А)',
            name: 'name_desc',
        },
        {
            viewName: 'Цене (низкая > высокая)',
            name: 'cost_asc',
        },
        {
            viewName: 'Цене (высокая > низкая)',
            name: 'cost_desc',
        },
    ]
    @Watch('initialSortBy') onInitialSortByChange() {
        if (this.initialSortBy !== this.sortBy.name) this.setSortByName(this.initialSortBy)
    }
    @Emit('sort') sortByChange(sortEl: {
        viewName: string,
        name: string,
    }) {
        this.sortBy = sortEl
        return this.sortBy.name
    }
    @Emit('showFilterDrawer')
    showFilterDrawer() {
        return true
    }
    @Emit('showQuickAddDialog')
    showQuickAddDialog() {
        return true
    }
    @Emit('update:viewListMode')
    viewListModeChange(e: 'grid' | 'list') {
        return e
    }
    setSortByName(name: string) {
        let fSortBy = this.sortList.find((item) => {
            return name === item.name
        })
        this.sortBy = fSortBy ? fSortBy : this.sortBy
    }
    created() {
        if (this.initialSortBy) this.setSortByName(this.initialSortBy)
    }
}